export const PROGRAM_CHANGE_REQUEST_MANAGER = 'program-change-request-manager'

export const EXPENSE_REPORT_FORM = 'expense-report-form'
export const ZNI_CHECKED = 'zni-checked'
export const REPORT_FORM = 'report-form'
export const EXPENSE_REPORT_PREV_YEAR_FORM = 'expense-report-prev-year-form'
export const RESULT_VALUE_ACHIEVEMENT_REPORT_FORM = 'result-value-achievement-report-form'
export const QUESTIONNAIRE = 'questionnaire'
export const POINT = 'point'
